import { cx } from 'cva'
import Image from 'next/image'
import Link from 'next/link'
import type { FC } from 'react'
import type { ImageData, PhaseTagType } from '../../frontend-types'
import { CarouselCardImages } from '../molecules/CarouselCardImages'
import { PhaseTag } from './PhaseTag'
import { PlaceholderImage } from './PlaceholderImage'
import { Tag } from './Tag'

export type CardVenueType = {
	slug: string
	title: string
	category: string
	location: string
	images: ImageData[]
	phaseTag: PhaseTagType
	url: string
}

export type CardVenueProps = {
	cardVenue: CardVenueType
}

export const CardVenue: FC<CardVenueProps> = ({ cardVenue }) => {
	const { title, category, images, location, phaseTag, url } = cardVenue

	const imagesSizes =
		'(max-width: 767px) 100vw, (max-width: 1023px) 50vw, (max-width: 1559px) 66.67vw, 456px'
	return (
		<Link href={url} target="_self" className="flex h-full flex-col group/card-venue">
			<div className="w-full flex-shrink-0 overflow-hidden rounded-t-sm bg-blue-tint-10">
				{images.length > 1 ? (
					<CarouselCardImages images={images} imagesSizes={imagesSizes} />
				) : images.length === 1 ? (
					<div className="relative h-auto aspect-video w-full overflow-hidden rounded-tl-sm tablet-p:rounded-tl-none">
						<Image
							src={images[0].src}
							alt={images[0].alt}
							fill
							className="object-cover group-hover/card-venue:scale-105 transition-all ease-in-out duration-300"
							sizes={imagesSizes}
						/>
					</div>
				) : (
					<div className="aspect-video h-auto w-full">
						<PlaceholderImage />
					</div>
				)}
			</div>
			<div className="bg-blue-tint-10 p-2xl relative flex-1">
				<div className="flex flex-1 flex-col gap-y-4xl relative z-10 h-full">
					<div>
						{category && <Tag label={category} className="mb-md" />}
						<span className="block text-h4 text-blue group-hover/card-venue:text-blue-shade-40 group-active/card-venue:text-blue-shade-70">
							{title}
						</span>
						{location && <span className="mt-xs block text-h6 text-blue-shade-70">{location}</span>}
					</div>
					<div className="mt-auto flex items-center">
						<PhaseTag phaseTag={phaseTag} cardSize="small" />
					</div>
				</div>
				<div
					className="absolute bottom-0 left-0 bg-blue-tint-20 w-full h-0 group-hover/card-venue:h-full transition-all ease-in-out duration-300 pointer-events-none z-0"
					aria-hidden="true"
				/>
				<div
					className={cx(
						'absolute right-0 bottom-0 h-(length:--stroke-sm) bg-blue left-0 pointer-events-none transition-all ease-in-out duration-150 z-15',
						'group-hover/card-venue:bg-blue-shade-40 group-active/card-venue:bg-blue-shade-70 group-hover/card-venue:h-(length:--stroke-md)',
					)}
					aria-hidden="true"
				/>
			</div>
		</Link>
	)
}
